/**
 * Radix modal overlays (dropdown menus, dialogs, selects) set
 * `document.body.style.pointerEvents = 'none'` while open and remove it on close.
 *
 * If the app navigates away while an overlay is still open — most commonly clicking
 * "Sign Out" inside the user-menu dropdown, which calls setLocation('/login') and
 * synchronously unmounts the whole tree before Radix runs its close cleanup — the
 * style is left stuck on <body>. The next page (the login screen) then renders but is
 * completely unclickable: passkey and social-login buttons "do nothing" until a full
 * page refresh rebuilds the document and drops the inline style. Safari is the most
 * affected by this timing.
 *
 * This releases that stuck style. It only clears the exact `none` value an overlay
 * leaves behind, so it never clobbers an intentional pointer-events value.
 */
export function releaseStuckOverlayPointerEvents(doc: Document = document): void {
  if (doc.body.style.pointerEvents === "none") {
    doc.body.style.pointerEvents = "";
  }
}
